import { Button, Modal } from '..';

type ConfirmModalProps = {
  title?: string;
  open: boolean;
  saving?: boolean;
  titleClassName?: string;
  onClose: () => void;
  onConfirm: () => void;
  confirmButtonLabel?: string;
  confirmButtonClassName?: string;
  children?: React.ReactNode;
};

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  saving = false,
  title = 'Confirm',
  titleClassName,
  onClose,
  onConfirm,
  children,
  confirmButtonClassName = 'w-full',
  confirmButtonLabel = 'Confirm',
}) => {
  return (
    <Modal
      size="small"
      title={title}
      open={open}
      titleClassName={titleClassName}
      onClose={onClose}
    >
      {children && children}
      <div className="flex flex-col gap-y-md justify-center items-center mt-md">
        <Button
          size="large"
          label={confirmButtonLabel}
          disabled={saving}
          className={confirmButtonClassName}
          onClick={onConfirm}
          loading={saving}
        />
        <Button
          size="large"
          type="light"
          label="Cancel"
          className="w-full"
          onClick={onClose}
        />
      </div>
    </Modal>
  );
};
